export class FormulaireModel {
    Telephone: string;
    Motif: string;
    SousMotif: string;
    Demande: string;
    PiecesJointes: PieceJointeModel[];
    Fournisseur: string;
}

export class PieceJointeModel {
    Nom: string;
    Stream: string | ArrayBuffer;
}